// function getTotalSavings() {
//   const target = document.querySelector('.z21-total-savings');
//   let total = 0;
//   for (const i of document.querySelectorAll('.t4s-cart_meta_prices')) {
//     if (i.querySelector('del span.money')) {
//         let ori = (parseFloat(i.querySelector('del span.money').textContent.substring(2)) - parseFloat(i.querySelector('ins span.money').textContent.substring(2))) * parseFloat(i.parentElement.parentElement.querySelector('.t4s-quantity-cart-item input').value);
//         total += ori;
//     }
//   }

//   if (total === 0) {
//     $('.z21-savings-1').hide();
//     return;
//   }
//   document.querySelector('.z21-total-savings').innerHTML = '-RM' + total.toFixed(2);
// }
// START Update the currency format
function formatMoney(amount, moneyFormat) {
  moneyFormat = moneyFormat.replace('{{amount}}', (amount / 100).toFixed(2));
  return moneyFormat;
}

function getTotalSavings() {
  const target = document.querySelector('.z21-total-savings');
  const currency = target.getAttribute('data-currency') || 'RM'; // Fallback to MYR if no currency is set
  const moneyFormat = target.getAttribute('data-money-format') || `${currency} {{amount}}`; // Fallback format
  let total = 0;

  for (const i of document.querySelectorAll('.t4s-cart_meta_prices')) {
    const originalPriceElement = i.querySelector('del span.money');
    const discountedPriceElement = i.querySelector('ins span.money');
    const quantityElement = i.parentElement.parentElement.querySelector('.t4s-quantity-cart-item input');

    if (originalPriceElement && discountedPriceElement && quantityElement) {
      let originalPrice = parseFloat(originalPriceElement.textContent.substring(2)) * 100;
      let discountedPrice = parseFloat(discountedPriceElement.textContent.substring(2)) * 100;
      let quantity = parseFloat(quantityElement.value);

      let savings = (originalPrice - discountedPrice) * quantity;
      total += savings;
    }
  }

  if (total === 0) {
    $('.z21-savings-1').hide();
    return;
  }

  target.innerHTML = `-${formatMoney(total, moneyFormat)}`;
}
// END Update the currency format

function updateProgressBar() {
  const progress_bar = document.querySelector('.progress-bar');
  const progress_header = document.querySelector('.progress-bar-header');
  progress_header.innerHTML = '';
  const subtotal = parseFloat(document.querySelector('.t4s-cart__totalPrice span').textContent.substring(2));
  const tier_1 = progress_bar.dataset.tier1;
  const tier_1_reward = progress_bar.dataset.reward1;  
  const tier_2 = progress_bar.dataset.tier2;
  const tier_2_reward = progress_bar.dataset.reward2;  
  const progress_block = document.querySelector('.progress-block');
  
  // Multi tier
  if (tier_1_reward && tier_2_reward) {
    const total_progress = parseFloat(tier_1) + parseFloat(tier_2);
    if (subtotal >= tier_2 ) {
      progress_block.style.width = '100%';
      progress_block.innerHTML = '100%';
      
      progress_header.innerHTML = 'You have earned <b>' + tier_2_reward + '</b>';
    } else if (subtotal >= tier_1 && subtotal < tier_2) {
      const price_diff = (tier_2 - subtotal).toFixed(2);

      const pct = (subtotal / total_progress * 100).toFixed(2);
      progress_block.style.width = pct + '%';
      progress_block.innerHTML = pct + '%';

      progress_header.innerHTML = 'You have earned <b>' + tier_1_reward + '</b>. You are <b style="color:red;">RM' + price_diff + '</b> away from ' + tier_2_reward;
    } else {
      const price_diff = (tier_1 - subtotal).toFixed(2);

      const pct = (subtotal / total_progress * 100).toFixed(2);
      progress_block.style.width = pct + '%';
      progress_block.innerHTML = pct + '%';
      
      progress_header.innerHTML = 'You are <b style="color:red;">RM' + price_diff + '</b> away from ' + tier_1_reward;
    }
  // Single tier
  } else if (!tier_2_reward) {
    if (subtotal >= tier_1) {
      console.log(tier_1_reward);
      progress_block.style.width = '100%';
      progress_block.innerHTML = '100%';
      
      progress_header.innerHTML = 'You have earned <b>' + tier_1_reward + '</b>';
    } else {
      const price_diff = (tier_1 - subtotal).toFixed(2);
      const pct = (subtotal /tier_1  * 100).toFixed(2);
      progress_block.style.width = pct + '%';
      progress_block.innerHTML = pct + '%';
      
      progress_header.innerHTML = 'You are <b style="color:red;">RM' + price_diff + '</b> away from ' + tier_1_reward;
    }
  } else {
    
  }
}

function checkIfBarbie() {
 const barbie_products = ['Magic Mirror In Iconic Silo Head Necklace','Iconic B With Dangling Silo Head Pendant Necklace','Iconic B With Dangling Silo Head Pendant Bracelet','Iconic B Dangling Pendant Earrings', 'Iconic B Pendant Jewellery Collection Set of 3','Iconic B Pendant Jewellery Collection Set of 2'];
 const progress_bar = document.querySelector('.z21-progress-bar');
 progress_bar.classList.remove('hide-barbie'); 
   for (const cart_item of document.querySelectorAll('.t4s-page_cart__title')) {
    if (barbie_products.includes(cart_item.textContent)) {
      progress_bar.classList.add('hide-barbie');
    }
  }
}

function onDOMContentLoaded() {
  getTotalSavings();
  updateProgressBar();

  for (const j of document.querySelectorAll('input.t4s-quantity-input')) {
    $(this).change(function() {
      getTotalSavings();
      updateProgressBar();
      checkIfBarbie();
    });
  }

  for (const k of document.querySelectorAll('.t4s-page_cart__remove svg')) {
    $(this).click(function() {
      setTimeout(() => {
        getTotalSavings();
        updateProgressBar();
        checkIfBarbie();
      }, 1000);
    });
  }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onDOMContentLoaded, {once: true})
} else {
  onDOMContentLoaded();
}

